import { Routes } from '@angular/router';
import { authenticationGuard, AuthModule } from '@siat-fe/auth';
import { Layout } from '@siat-fe/layout';

export const appRoutes: Routes = [
  {
    path: 'external-client',
    data: {
      title: 'Accesso esterno',
      showBackButton: false,
    },
    loadComponent: () =>
      import('./pages/external-client/external-client.component').then(
        (m) => m.ExternalClientComponent,
      ),
  },
  {
    path: '',
    loadChildren: () => AuthModule,
  },
  {
    path: 'apps',
    canActivate: [authenticationGuard],
    loadComponent: () =>
      import('./pages/available-apps/available-apps.component').then(
        (m) => m.AvailableAppsComponent,
      ),
  },
  {
    path: '404-page',
    data: {
      title: 'ERROR_PAGES.404.TITLE',
      showBackButton: false,
    },
    loadComponent: () =>
      import('./pages/404-page/404-page.component').then(
        (m) => m.NotFoundPageComponent,
      ),
  },
  Layout.childRoutes([
    {
      path: 'amministrazione',
      canActivate: [authenticationGuard],
      loadChildren: () =>
        import('./features/amministrazione/amministrazione.routes').then(
          (m) => m.amministrazioneRoutes,
        ),
    },
    {
      path: 'home',
      canActivate: [authenticationGuard],
      loadChildren: () =>
        import('./features/home/home.routes').then((m) => m.homeRoutes),
    },
  ]),
  {
    path: '**',
    redirectTo: '404-page',
  },
];
